import manifest from '@nula/emoji-manifest/emoji-manifest.json';
import type { EmojiGroup } from '@/components/emoji-renderer/types';

export const EMOJI_GROUPS: EmojiGroup[] = manifest;

const NAMES = new Map(
  EMOJI_GROUPS.flatMap(group => group.emojis.map(emoji => [`${group.id}/${emoji.id}`, emoji.name] as const)),
);

/** `:<slug(name)>:`, the same text the server's document walk gives an emoji. */
export function emojiShortcode(group: string, id: string): string {
  const name = NAMES.get(`${group}/${id}`);
  if (name === undefined) return ':emoji:';
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `:${slug}:`;
}
